import React from 'react';
import GenericTermsPage from '../../../components/GenericTermsPage';

const APP_NAME = 'Note & To-do';
const LAST_UPDATED_DATE = 'August 2025';

const TERMS_CONTENT = `
1.  Acceptance of Terms
    By using the Note & To-do app ("App"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, please do not use the App.

2.  Use License
    Permission is granted to temporarily download one copy of the App for personal, non-commercial transitory viewing only. This license does not allow you to modify or copy the materials, use them for any commercial purpose, or attempt to decompile or reverse engineer the App.
    Premium Tier: Certain features within the App ("Premium Features") require a valid, active subscription purchased through your device's app store (e.g., Apple App Store, Google Play Store). Access to Premium Features is contingent upon maintaining this subscription. Subscriptions are non-refundable in any circumstances, unless required by applicable law or the policies of the respective app store. Refunds, if any, are handled exclusively by the respective app store according to their policies.

3.  Disclaimer
    The materials within the App are provided on an 'as is' basis. CodeMates makes no warranties, expressed or implied, and disclaims all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property.

4.  Limitations
    In no event shall CodeMates or its suppliers be liable for any damages arising out of the use or inability to use the materials on the App.

5.  Accuracy of Materials
    The materials appearing in the App could include technical, typographical, or photographic errors. CodeMates does not warrant that any of the materials on the App are accurate, complete or current.

6.  Links
    CodeMates has not reviewed all of the sites linked to its App (if any) and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by CodeMates of the site. Use of any such linked website is at the user's own risk.

7.  Modifications
    CodeMates may revise these Terms of Service for its App at any time without notice. By using this App you are agreeing to be bound by the then current version of these Terms of Service.

8.  Governing Law
    Any legal suit, action, or proceeding arising out of, or related to, these Terms or the App shall be instituted exclusively in the courts of Hong Kong, although we retain the right to bring any suit, action, or proceeding against you for breach of these Terms in your country of residence or any other relevant country. You waive any and all objections to the exercise of jurisdiction over you by such courts and to venue in such courts.

9.  Contact Us
    If you have any questions about these Terms, please contact us at <a href="mailto:support.noteandtodo@codemates.app" style="color:#007bff;text-decoration:none;">support.noteandtodo@codemates.app</a>.
`;

function NoteAndToDoTermsPage() {
  return (
    <GenericTermsPage
      appName={APP_NAME}
      lastUpdatedDate={LAST_UPDATED_DATE}
      termsContent={TERMS_CONTENT}
    />
  );
}

export default NoteAndToDoTermsPage; 